/* eslint-disable no-console */

import { register } from 'register-service-worker'

const serviceWorkerRegistration = {
  initialize(firebaseMessaging) {
    if (process.env.NODE_ENV === 'production') {
      register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
          console.log(
            'App is being served from cache by a service worker.\n' +
            'For more details, visit https://goo.gl/AFskqB'
          )
        },
        registered(registration) {
          if (firebaseMessaging) {
            firebaseMessaging.useServiceWorker(registration);
            firebaseMessaging.onMessage((payload) => {
              const notificationTitle = payload.data.title || 'Message for you';
              const notificationOptions = {
                body: payload.data.message,
                icon: payload.data.icon
              };

              return registration.showNotification(notificationTitle, notificationOptions);
            });
          }

          console.log('Service worker has been registered.')
        },
        cached() {
          console.log('Content has been cached for offline use.')
        },
        updatefound() {
          console.log('New content is downloading.')
        },
        updated(registration) {
          console.log('New content is available; please refresh.')
          window.alert('New content available, refresh now!');
          registration.waiting.postMessage({ action: 'skipWaiting' });
        },
        offline() {
          console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
          console.error('Error during service worker registration:', error)
        }
      })
    }
  }
};

export {
  serviceWorkerRegistration
}
